
import { defineComponent } from "vue";
// import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
// import { onActivated, onDeactivated } from "vue";

export default defineComponent({
  name: "HomeView",
  mounted() {
    this.C_HalfNo = this.Car_NoOfSides / 2;
    this.CW_I = new Array(this.C_HalfNo + 1);
    this.C_ClcW = new Array(this.C_HalfNo);

    this.Carousel();
  },

  components: {
    // HelloWorld,
  },

  data() {
    return {
      compnayName:localStorage.getItem("companyName"),
      companyIconFileName: "" + localStorage.getItem("companyIconFile"),
      whatsappNumber: "" + localStorage.getItem("whatsappNumber"),

      isLogginSuccessfull: false,

      // 7 variables to control behavior
      Car_Image_Width: 640,
      Car_Image_Height: 425,
      Car_Border: true, // true or false
      Car_Border_Color: "white",
      Car_Speed: 2,
      Car_Direction: true, // true or false
      Car_NoOfSides: 12, // must be 4, 6, 8 or 12
      //c:(Number)(this.Car_Image_Height) + 2,
      C_HalfNo: Number(this.Car_NoOfSides) / 2,

      // CW_I: new Array(8 / 2 + 1),
      // C_ClcW: new Array(8 / 2),

      CW_I: new Array(1),
      C_ClcW: new Array(0),

      C_Coef: [
        (3 * Math.PI) / 2,
        0,
        (3 * Math.PI) / 2,
        (11 * Math.PI) / 6,
        Math.PI / 6,
        (3 * Math.PI) / 2,
        (7 * Math.PI) / 4,
        0,
        Math.PI / 4,
        (3 * Math.PI) / 2,
        (5 * Math.PI) / 3,
        (11 * Math.PI) / 6,
        0,
        Math.PI / 6,
        Math.PI / 3,
      ],

      Car_Image_Sources: [
        // "photo31.jfif",
        // "security.html",
        // "camera.jfif",
        // "camera.html", // NOTE No comma after last line
        // "photo2.jfif",
        // "security.html",
        // "photo3.jfif",
        // "", //this slide isn't linked
        // "photo4.jfif",
        // "security.html", // NOTE No comma after last line
        // "carparksecurity.jfif",
        // "carparksecurity.html",
        "Security Camera Room.jfif",
        "security.html",
        "Gate SecurityOfficer.jfif",
        "camera.html", // NOTE No comma after last line
        "Man with Lock.jpg",
        "security.html",
        "Long Camera.jfif",
        "", //this slide isn't linked
        "Building security.jfif",
        "security.html", // NOTE No comma after last line
        "Carpark Security.jfif",
        "carparksecurity.html",
      ],

      C_CoefOf:
        Number(this.Car_NoOfSides) == 4
          ? 0
          : Number(this.Car_NoOfSides) == 6
          ? 2
          : Number(this.Car_NoOfSides) == 8
          ? 5
          : 9,
      C_Pre_Img: new Array(4),
      C_Angle: this.Car_Direction
        ? Math.PI / (Number(this.Car_NoOfSides) / 2)
        : 0,
      C_CrImg: Number(this.Car_NoOfSides),
      C_MaxW: 0,
      C_TotalW: 0,
      C_Stppd: false,
      i: 0,
      C_LeftOffset: 0,
    };
  },
  methods: {
    Carousel() {
      if (document.getElementById("Carousel")) {
        console.log("inside Carousel method");

        // document
        //   .getElementById("Carousel")
        //   ?.addEventListener("mouseenter", () => {
        //     alert("test event hendler");
        //   });

        // console.log(
        //   "this.Car_Image_Sources.length : ",
        //   this.Car_Image_Sources.length
        // );

        for (var i = 0; i < this.Car_Image_Sources.length; i += 2) {
          this.C_Pre_Img[i] = new Image();
          this.C_Pre_Img[i].src = this.Car_Image_Sources[i];

          // console.log("this.C_Pre_Img[i].src : ", this.C_Pre_Img[i].src);
        }

        // console.log("this.Car_NoOfSides : ", this.Car_NoOfSides);
        // console.log("this.C_HalfNo : ", this.C_HalfNo);

        this.C_MaxW =
          this.Car_Image_Width / Math.sin(Math.PI / this.Car_NoOfSides) +
          this.C_HalfNo +
          1;

        //console.log("C_MaxW : ", this.C_MaxW);

        var Car_Div = document.getElementById("Carousel");
        for (let i = 0; i < this.C_HalfNo; i++) {
          //console.log("C_MaxW : ", this.C_MaxW);

          this.CW_I[i] = document.createElement("img");
          Car_Div?.appendChild(this.CW_I[i]);
          this.CW_I[i].style.position = "absolute";
          this.CW_I[i].style.top = 0 + "px";
          this.CW_I[i].style.height = this.Car_Image_Height + "px";

          if (this.Car_Border) {
            this.CW_I[i].style.borderStyle = "solid";
            this.CW_I[i].style.borderWidth = 1 + "px";
            this.CW_I[i].style.borderColor = this.Car_Border_Color;
          }

          this.CW_I[i].src = this.Car_Image_Sources[2 * i];
          //if (i == 0) this.CW_I[0].src = "photo1.jfif";

          this.CW_I[i].lnk = this.Car_Image_Sources[2 * i + 1];

          // console.log(
          //   "this.Car_Image_Sources[" + 2 * i + "] : ",
          //   this.Car_Image_Sources[2 * i]
          // );
          //console.log("CW_I[" + i + "] : 11", this.CW_I[i]);

          //this.CW_I[i].onclick = this.C_LdLnk;
          //this.CW_I[i].onmouseover = this.C_Stp;
          //this.CW_I[i].onmouseout = this.C_Rstrt;

          // this.CW_I[i].addEventListener("mouseleave", () => {
          //   console.log("image mouseleave test");
          //   this.C_Stppd = false;
          // });

          this.CW_I[i].addEventListener("mouseover", () => {
            console.log("image mouseover test");

            this.CW_I[i].style.cursor = this.CW_I[i].lnk
              ? "pointer"
              : "default";
            this.C_Stppd = true;
          });

          this.CW_I[i].addEventListener("mouseout", () => {
            console.log("image mouseout test");

            this.CW_I[i].style.cursor = this.CW_I[i].lnk
              ? "pointer"
              : "default";
            this.C_Stppd = false;
          });
        }

        // this.CW_I[0].src = "photo1.jfif";
        this.CW_I[0].src = "Event Security3.png";
        //this.CW_I[4].src = "photo1.jfif";

        //this.CarImages();
        setInterval(() => {
          this.CarImages();
        }, 50);
      }
    },
    C_Stp() {
      //(imageNumber: number) {
      //this.style.cursor=this.lnk?"pointer":"default";C_Stppd=true;
      // this.CW_I[imageNumber].style.cursor = this.CW_I[imageNumber].lnk
      //   ? "pointer"
      //   : "default";
      this.C_Stppd = true;
      console.log("enter mouse over test...");
      //this.C_Stppd = true;
    },
    C_Rstrt() {
      //this.style.cursor=this.lnk?"pointer":"default";C_Stppd=true;
      console.log("leave mouse over test...");
      this.C_Stppd = false;
    },
    CarImages() {
      if (!this.C_Stppd) {
        this.C_TotalW = 0;
        for (let i = 0; i < this.C_HalfNo; i++) {
          this.C_ClcW[i] = Math.round(
            Math.cos(Math.abs(this.C_Coef[this.C_CoefOf + i] + this.C_Angle)) *
              this.Car_Image_Width
          );
          this.C_TotalW += this.C_ClcW[i];
        }
        this.C_LeftOffset = (this.C_MaxW - this.C_TotalW) / 2;
        for (let i = 0; i < this.C_HalfNo; i++) {
          this.CW_I[i].style.left = this.C_LeftOffset + "px";
          this.CW_I[i].style.width = this.C_ClcW[i] + "px";
          this.C_LeftOffset += this.C_ClcW[i];
        }
        this.C_Angle +=
          (this.Car_Speed / 720) * Math.PI * (this.Car_Direction ? -1 : 1);
        if (
          (this.Car_Direction && this.C_Angle <= 0) ||
          (!this.Car_Direction && this.C_Angle >= Math.PI / this.C_HalfNo)
        ) {
          if (this.C_CrImg == this.Car_Image_Sources.length) this.C_CrImg = 0;

          if (this.Car_Direction) {
            this.CW_I[this.C_HalfNo] = this.CW_I[0];

            for (let i = 0; i < this.C_HalfNo; i++)
              this.CW_I[i] = this.CW_I[i + 1];

            //console.log("this.C_HalfNo : 11", this.C_HalfNo);

            // console.log(
            //   "tthis.CW_I[this.C_HalfNo - 1] : 22",
            //   this.CW_I[this.C_HalfNo - 1]
            // );

            // this.CW_I[this.C_HalfNo - 1].src =
            //   this.Car_Image_Sources[this.C_CrImg];
            // this.CW_I[this.C_HalfNo - 1].lnk =
            //   this.Car_Image_Sources[this.C_CrImg + 1];
          } else {
            for (let i = 4; i > 0; i--) this.CW_I[i] = this.CW_I[i - 1];
            this.CW_I[0] = this.CW_I[this.C_HalfNo];
            this.CW_I[0].src = this.Car_Image_Sources[this.C_CrImg];
            // this.CW_I[0].lnk = this.Car_Image_Sources[this.C_CrImg + 1];
            this.CW_I[0].lnk = this.Car_Image_Sources[this.C_CrImg + 1];
          }
          this.C_Angle = this.Car_Direction ? Math.PI / this.C_HalfNo : 0;
          this.C_CrImg = this.C_CrImg + 2;
        }
      }
    },
    // activated() {
    //   console.log("tab-info activated");
    // },
    // deactivated() {
    //   console.log("tab-info deactivated");
    // },
    // mounted() {
    //   this.Carousel();
    //   console.log("home page called.......");
    //   console.log("home page called.......");
    //   console.log("home page called.......");
    //   console.log("home page called.......");
    //   console.log("home page called.......");
    //   console.log("home page called.......");
    //   console.log("home page called.......");
    // },
    // created() {
    //   this.Carousel();

    //   console.log("home page created.......created");
    //   var btnCarouselInnerHtml = document.getElementById("btnCarousel");
    //   console.log("btnCarouselInnerHtml : ", btnCarouselInnerHtml);
    //   btnCarouselInnerHtml?.click();
    //   document.getElementById("btnCarousel")?.click();
    // },
    // activated() {
    //   console.log("home page activated.......activated");
    //   var btnCarouselInnerHtml = document.getElementById("btnCarousel");
    //   console.log("btnCarouselInnerHtml : ", btnCarouselInnerHtml);
    //   document.getElementById("btnCarousel")?.click();
    // },
  },
});

//console.log("home page called.......111");

var btnCarouselInnerHtml = document.getElementById("btnCarousel");
//console.log("btnCarouselInnerHtml : ", btnCarouselInnerHtml);
document.getElementById("btnCarousel")?.click();
//console.log("home page called.......222");
